import ShowQuestionDetail from "./ShowQuestionDetail";
export default ShowQuestionDetail;
